import React, { Component } from 'react';

import TurnedIn from 'material-ui/svg-icons/action/turned-in';
import TurnedInNot from 'material-ui/svg-icons/action/turned-in-not';

import { Edit } from 'components/detail';
import { SimpleForm } from 'components/form';
import {
  TextInput,
  MultipleChoicesFromDataInput,
  FileInput,
} from 'components/input';

import { ImageField } from 'components/field';

import * as urls from './urls';

export class ShopTemplateEdit extends Component {

  handleSubmit = (props, basePath) => (record) => {
    const selected_ids = new Set(record['category_ids']);
    const original_ids = new Set(props.data['category_ids']);

    const params = {
      en: record['en'],
      translation: record['translation'],
      category_ids_add: [...selected_ids].filter(x => !original_ids.has(x)),
      category_ids_remove: [...original_ids].filter(x => !selected_ids.has(x)),
    };

    props.crudUpdate(props.resource, props.id,
      params, props.data, props.editBackendPath, basePath);
  };

  render() {
    return (
      <Edit
        editBackendPath={urls.shopTemplateEditBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm>
          <TextInput source="en" label="Name" isRequired={true}/>
          <TextInput source="translation" label="Name(Local)" isRequired={true}/>
          <MultipleChoicesFromDataInput
            label="Categories"
            source="category_ids"
            choiceSource="category_choices"
            options={{ checkedIcon: <TurnedIn />, uncheckedIcon: <TurnedInNot /> }}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export class ShopCategoryEdit extends Component {

  handleSubmit = (props, basePath) => (record) => {
    const selected_ids = new Set(record['item_ids']);
    const original_ids = new Set(props.data['item_ids']);

    const params = {
      en: record['en'],
      translation: record['translation'],
      item_ids_add: [...selected_ids].filter(x => !original_ids.has(x)),
      item_ids_remove: [...original_ids].filter(x => !selected_ids.has(x)),
    };

    props.crudUpdate(props.resource, props.id,
      params, props.data, props.editBackendPath, basePath);
  };

  render() {
    return (
      <Edit
        editBackendPath={urls.shopCategoryEditBackendPath}
        handleSubmit={this.handleSubmit}
        {...this.props}
      >
        <SimpleForm>
          <TextInput source="en" label="Name" isRequired={true}/>
          <TextInput source="translation" label="Name(Local)" isRequired={true}/>
          <MultipleChoicesFromDataInput
            label="Items"
            source="item_ids"
            choiceSource="item_choices"
            options={{ checkedIcon: <TurnedIn />, uncheckedIcon: <TurnedInNot /> }}
          />
        </SimpleForm>
      </Edit>
    );
  }
}

export class ShopItemEdit extends Component {

  handleSubmit = (props, basePath) => (record) => {
    const formDataRecord = new FormData();
    formDataRecord.append('en', record['en']);
    formDataRecord.append('translation', record['translation']);
    if (record['image'])
      formDataRecord.append('image', record['image']);

    props.crudUpdate(props.resource, props.id,
      formDataRecord, props.data, props.editBackendPath, basePath);
  };

  render() {
    return (
      <Edit
        editBackendPath={urls.shopItemEditBackendPath}
        handleSubmit={this.handleSubmit}
        updateDataOnMount={false}
        {...this.props}
      >
        <SimpleForm>
          <TextInput source="en" label="Name" isRequired={true}/>
          <TextInput source="translation" label="Name(Local)" isRequired={true}/>
          <FileInput source="image" label="Image" placeholder={<p>Select or drop your image here</p>}>
            <ImageField source="src" title="title"/>
          </FileInput>
        </SimpleForm>
      </Edit>
    );
  }
}


// WEBPACK FOOTER //
// ./src/routes/shop/ShopTemplateEdit.js